import fetcher, { NOT_FOUND, STATUS_OK } from "../../libs/fetcher";
import QueryString from "qs";
import {
    IAInventoryInvoiceFiles,
    IAllAssetsIndexParams,
    IAssetIndexParams,
    IAssetIndexResponse,
    IAssetsMonitoringAssetsParams,
    IAssetsStoreParams,
    IAssetsStoreResponse
} from "models/Assets";

export const indexAssets = async ({ project_id, table, ...query }: IAssetIndexParams): Promise<IAssetIndexResponse> => {
    const url = `/projects/${project_id}/${table}`;
    let response: IAssetIndexResponse = { data: [], totalItems: 0, error: true };

    // Objeto donde las claves son cadenas (string) y los valores pueden ser o bien una cadena (string) o un número (number).
    let params: Record<string, string | number> = {};

    // Verificar si query tiene valores y construir los parámetros
    if (query) {
        for (const [key, value] of Object.entries(query)) {
            // Solo agregar valores que no sean undefined ni -1
            if (value !== undefined && value !== -1) {
                params[key] = value;
            }
        }
    }

    try {
        const fetchResponse = await fetcher({
            url,
            method: 'GET',
            params
        });

        if (fetchResponse === undefined) {
            throw new Error('Request failed');
        }
        const { fetch } = fetchResponse;

        // console.log("🚀 ~ file: assets.ts:44 ~ indexAssets ~ fetch:", fetch)

        if (typeof fetch === 'string') {
            throw "Error al recibir la respuesta";
        } else if (fetch instanceof Object) {
            if ('status' in fetch && fetch.status === STATUS_OK) {
                const responseData = 'data' in fetch ? fetch.data : null;
                if (responseData) {
                    response.data = responseData.data;
                    response.error = false;
                    response.totalItems = responseData.totalItems;
                }
            }
        }

        return response;
    } catch (error) {
        return response;
    }
}

export const indexAllAssets = async ({ table, query }: IAllAssetsIndexParams): Promise<IAssetIndexResponse> => {
    const url = `/${table}`;
    let response: IAssetIndexResponse = { data: [], totalItems: 0, error: true };

    try {
        const fetchResponse = await fetcher({
            url,
            method: 'GET',
            params: query,
            paramsSerializer: params => QueryString.stringify(params, { arrayFormat: 'repeat' })
        });

        if (fetchResponse === undefined) {
            throw new Error('Request failed');
        }
        const { fetch } = fetchResponse;

        // console.log("🚀 ~ file: assets.ts:110 ~ indexAllAssets ~ fetch:", fetch)

        if (typeof fetch === 'string') {
            throw "Error al recibir la respuesta";
        } else if (fetch instanceof Object) {
            if ('status' in fetch && fetch.status === STATUS_OK) {
                const responseData = 'data' in fetch ? fetch.data : null;
                if (responseData) {
                    response.data = responseData.data;
                    response.error = false;
                    response.totalItems = responseData.totalItems;
                }
            }
        }

        return response;
    } catch (error) {
        return response;
    }
}

export const indexAssetsMonitoring = async ({ project_id, table }: IAssetsMonitoringAssetsParams): Promise<IAssetIndexResponse> => {
    const url = `/projects/${project_id}/${table}/components/monitoring`;
    let response: IAssetIndexResponse = { data: [], totalItems: 0, error: true };

    try {
        const fetchResponse = await fetcher({
            url,
            method: 'GET'
        });

        if (fetchResponse === undefined) {
            throw new Error('Request failed');
        }
        const { fetch } = fetchResponse;

        // console.log("🚀 ~ file: assets.ts:85 ~ indexAssetsMonitoring ~ fetch:", fetch)

        if (typeof fetch === 'string') {
            throw "Error al recibir la respuesta";
        } else if (fetch instanceof Object) {
            if ('status' in fetch && fetch.status === STATUS_OK) {
                const responseData = 'data' in fetch ? fetch.data : null;
                if (responseData) {
                    response.data = responseData.data;
                    response.error = false;
                    response.totalItems = responseData.totalItems;
                }
            }
        }

        return response;
    } catch (error) {
        return response;
    }
}

export const storeAssets = async ({ project_id, data, table = 'assets_its' }: IAssetsStoreParams): Promise<IAssetsStoreResponse> => {
    const url = `/projects/${project_id}/${table}`;
    let defaultResponse: IAssetsStoreResponse = { status: 501, data: undefined };
    try {
        const res = await fetcher({
            url: `${url}`,
            method: 'POST',
            data
        });
        if (!res) throw new Error('Request failed');

        const { fetch } = res;

        // console.log("🚀 ~ store ~ fetch:", fetch)

        if (typeof fetch === 'string') throw new Error('Request Unknown');

        if (fetch instanceof Object) {
            if ('status' in fetch) {

                const responseData = 'data' in fetch ? fetch.data : null;

                if (fetch.status === STATUS_OK && responseData) {
                    defaultResponse.data = responseData;
                    defaultResponse.status = fetch.status;
                } else if (fetch.status === NOT_FOUND && responseData) {
                    defaultResponse.status = fetch.status;
                    defaultResponse.data = responseData;
                }
            }
        }
        return defaultResponse;
    } catch (error) {
        return defaultResponse;
    }
}

export const uploadInventoryInvoiceFiles = async ({ project_id, table, id, data }: IAInventoryInvoiceFiles): Promise<boolean> => {
    const url = `/projects/${project_id}/${table}/${id}/upload`;
    let response = false;
    try {
        await fetcher({
            url: `${url}`,
            method: 'POST',
            data
        });
        return true;
    } catch (error) {
        return response;
    }
}

export const updateAssets = async ({ project_id, id, data, table }: IAssetsStoreParams): Promise<boolean> => {
    const url = `/projects/${project_id}/${table}/${id}`;
    let response = false;
    try {
        await fetcher({
            url,
            method: 'PUT',
            data
        });

        return true;
    } catch (error) {
        return response;
    }
}